import React from 'react';

import { downloadFileLink } from '../../../utils/downloadFile';

import { LinkCardCustom } from '../../../components/Cards/LinkCard';

function GenericCard({ title, desc, link }) {
    return (
        <LinkCardCustom
            link="#"
            onClick={() => downloadFileLink(`${title}.pdf`, link)}
            title={title}
            desc={desc}
            icons={{ left: { name: 'description' }, right: { name: 'file_download' } }}
        />
    );
}

export default GenericCard;
